"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailSchema = void 0;
const zod_1 = require("zod");
const __1 = require("..");
exports.EmailSchema = zod_1.z.object({
    subject: __1.LongStringSchema,
    senders: zod_1.z.array(zod_1.z.object({
        name: __1.ShortStringSchema,
        email: __1.LongStringSchema.email(),
    })),
    templateName: __1.ShortStringSchema,
    templateData: zod_1.z.record(zod_1.z.string()).optional(),
});
//# sourceMappingURL=email.js.map